// A server seed is keyed by its UTC day (`YYYY-MM-DD`), the same string a date field reads and
// writes, so the day a shopper picks is the day that is looked up, in every time zone.

const DAY_MS = 86_400_000;

/** The UTC day key `offsetDays` from `now`: 0 is today's seed, 1 the one committed for tomorrow. */
export function utcDayKey(now: Date, offsetDays = 0): string {
  return new Date(now.getTime() + offsetDays * DAY_MS).toISOString().slice(0, 10);
}
